import { Tree, Select } from 'antd';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { baseurl } from "./api";

const buildTreeData = (node) => {
  if (!node) return null;
  return {
    key: node.id,
    title: `${node.subject} (${node.type})`,
    children: node.children?.map(buildTreeData) || []
  };
};

export default function CorrespondenceTrail({ id = "689b3ae3f37f6cc3b7fe1968" }) {
  const [data, setData] = useState(null);
  const [trailType, setTrailType] = useState("reference");

  const fetchTrail = (type) => {
    axios.put(`${baseurl}/correspondence/trail/${id}`, { type })
      .then(res => setData(res.data))
      .catch(err => console.error(err));
  };

  useEffect(() => {
    fetchTrail(trailType);
  }, [id, trailType]);

  return (
    <div>
      <Select
        value={trailType}
        style={{ width: 200, marginBottom: 16 }}
        onChange={setTrailType}
        options={[
          { value: 'reference', label: 'Reference Trail' },
          { value: 'reply', label: 'Reply Trail' },
          { value: 'enclosure', label: 'Enclosure Trail' }
        ]}
      />
      <Tree
        treeData={data ? [buildTreeData(data)] : []}
        defaultExpandAll
        showLine={{ showLeafIcon: false }} // keeps arrows visible
      />
    </div>
  );
}
